import { ISelectType } from "@4uhub/lib4uhub";
import { GlobalAxios } from "../axios/axios-config";

const LIST_CATEGORY_ROUTE = process.env.REACT_APP_MAIN + "/api/v1/ListCategory/";

const LIST_CLASSIFICATION_ROUTE =
  process.env.REACT_APP_MAIN + "/api/v1/ListClassification/";

export const listCategoriesByProfileAccess = (params?: any) => {
  return GlobalAxios.get<ISelectType[]>(
    LIST_CATEGORY_ROUTE + "list/profile-access",
    { params }
  );
};

export const listClassificationsByProfileAccess = (params?: any) => {
  return GlobalAxios.get<ISelectType[]>(
    LIST_CLASSIFICATION_ROUTE + "list/profile-access",
    { params }
  );
};
